/**
 * Created by danielr on 2/27/17.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var RevisionedModel = require("models/RevisionedModel");
    var TwilioConfigModel = require("manager-models/data-sources/conversation-sources/types/TwilioConfigModel");
    var FacebookConfigModel = require("manager-models/data-sources/conversation-sources/types/FacebookConfigModel");
    var ApiResources = require("assets/data/apiResources.json");

    var SOURCE_TYPES = {
        BRAND_APP: 104,
        FACEBOOK: 102,
        TWILIO: 103,
        GOOGLE: 105
    };

    var SOURCE_TYPE_CONFIGURATION = {};
    SOURCE_TYPE_CONFIGURATION[SOURCE_TYPES.GOOGLE] = {
        isAllowed:  false, //function() { return LE.sessionManager.hasGoogleSourceFeature(); }, // Currently it's disabled anyway until we have backend ready
        path: "data/sources/google/activation",
        key: "google",
        kp: "",
        ConfigModel: TwilioConfigModel
    };

    SOURCE_TYPE_CONFIGURATION[SOURCE_TYPES.FACEBOOK] = {
        isAllowed: function() { return LEConfig.facebookConfiguration.showFacebookConnector; },
        path: "data/sources/facebook/activation",
        key: "facebook",
        kp: "facebook-connector",
        video: "https://player.vimeo.com/video/238902683",
        logo_uri: window.leImageBaseUrl + "src/modules/campaigns/assets/img/software/Messenger.png",
        ConfigModel: FacebookConfigModel
    };

    SOURCE_TYPE_CONFIGURATION[SOURCE_TYPES.TWILIO] = {
        isAllowed: true,
        path: "data/sources/twilio/activation",
        key: "twilio",
        kp: "sms-connector",
        video: "https://players.brightcove.net/902047215001/default_default/index.html?videoId=5275421544001",
        logo_uri: window.leImageBaseUrl + "src/modules/campaigns/assets/img/software/Twilio.png",
        ConfigModel: TwilioConfigModel
    };

    SOURCE_TYPE_CONFIGURATION[SOURCE_TYPES.BRAND_APP] = {
        isAllowed: function() { return !LEConfig.c4mMobileApp;},
        path: "data/sources/brandApp/activation",
        key: "brandApp",
        kp: "in-app-messaging",
        logo_uri: window.leImageBaseUrl + "src/modules/campaigns/assets/img/software/Brand-App.png",
        video: "https://www.youtube.com/embed/PfP3NC4hWY4",
        viewLink: true
    };


    var URL_PARAMETERS = {
        ACTIVATION: "&select=$all",
        CONFIG: "&select=$all&include_secured=true"
    };

    var KEYS = {
        ID: "id",
        TYPE: "type",
        NAME: "name",
        ENABLED: "configuration.enabled",
        CONFIGURATION: "configuration"
    };

    var ConnectorModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ConnectorModel = RevisionedModel.extend({
            resource: ApiResources.AccountConfig.SourceConnectors,
            SOURCE_TYPES: SOURCE_TYPES,
            SOURCE_TYPE_CONFIGURATION: SOURCE_TYPE_CONFIGURATION,
            KEYS: KEYS,
            name: "ConnectorModel",
            defaults: {
                id: null,
                type: null,
                name: "",
                configuration: {
                    enabled: false
                }
            },

            initialize: function (attrs, options) {
                options = options || {};
                this.urlParameters = options.urlParameters || URL_PARAMETERS.ACTIVATION;
                var typeConfiguration = this.getTypeConfiguration();
                if (_.isEmpty(typeConfiguration)) {
                    LEManager.logger.error("The type of the connector model is not supported", {type:this.getType()});
                    LEManager.logger.graph({ name: "The type of the connector model is not supported"});
                }
                else if (!_.isEmpty(typeConfiguration.ConfigModel)) {
                    this.configurationModel = new typeConfiguration.ConfigModel(this.getConfiguration(), {typeConfiguration:typeConfiguration});
                }

                RevisionedModel.prototype.initialize.call(this, attrs, options);
            },

            url: function(){
                var url = RevisionedModel.prototype.url.apply(this, arguments);
                url = url + this.urlParameters;
                return url;
            },

            parse: function(response, options) {
                //there is currently a bug in the api. the response is an array when saving the model instead of a flat object
                if (_.isArray(response)){
                    response = response[0];
                }
                return RevisionedModel.prototype.parse.call(this, response, options);
            },

            save: function (attrs, options) {
                options = options || {};
                this.urlParameters = options.urlParameters || URL_PARAMETERS.ACTIVATION;
                if (this.urlParameters === URL_PARAMETERS.CONFIG) {
                    this.pullConfigurationModelChanges();
                }

                return RevisionedModel.prototype.save.call(this, attrs, options);
            },

            getType: function () {
                return this.get(KEYS.TYPE);
            },
            getTypeConfiguration: function() {
                return SOURCE_TYPE_CONFIGURATION[this.getType()];
            },
            getName: function () {
                return this.get(KEYS.NAME);
            },
            getEnabled: function(){
                return this.get(KEYS.ENABLED);
            },
            setEnabled: function(enabled){
                this.set(KEYS.ENABLED, enabled);
            },
            getConfiguration: function(){
                return this.get(KEYS.CONFIGURATION);
            },
            setConfiguration: function(configuration){
                this.set(KEYS.CONFIGURATION, configuration);
            },
            getConfigurationModel: function(){
                return this.configurationModel;
            },
            pullConfigurationModelChanges: function () {
                if (this.configurationModel) {
                    this.setConfiguration(this.configurationModel.toJSON());
                }
            },
            isConfigStepComplete: function(){
                var isComplete = true;
                if (this.configurationModel) {
                    isComplete = this.configurationModel.isConfigStepComplete();
                }
                return isComplete;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    ConnectorModel.KEYS = KEYS;
    ConnectorModel.SOURCE_TYPES = SOURCE_TYPES;
    ConnectorModel.SOURCE_TYPE_CONFIGURATION = SOURCE_TYPE_CONFIGURATION;
    ConnectorModel.URL_PARAMETERS = URL_PARAMETERS;
    return ConnectorModel;
});

